import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {UsersService} from '../services/users.service';
import {SubscriptionStatuses} from '../enums/subscriptionStatuses.enum';
import {SubscriptionViewModel} from '../viewModels/subscription.viewModel';

@Injectable()
export class NoPricingGuard implements CanActivate {
    constructor(
        private readonly usersService: UsersService,
        private readonly router: Router
    ) {
    }

    canActivate() {
        return this.usersService.getUserSubscription()
            .pipe(
                map(subscription => {
                    if (subscription.status !== SubscriptionStatuses.CANCELLED) {
                        this.router.navigate(['dashboard']);

                        return false;
                    } else {
                        return true;
                    }
                }),
                catchError(() => of(true))
            );
    }
}
